import axios from 'axios';
import { toast } from 'react-toastify';
import {
  APP_SETTING_CREATE_PROJECT_VERSION_BEGIN,
  APP_SETTING_CREATE_PROJECT_VERSION_SUCCESS,
  APP_SETTING_CREATE_PROJECT_VERSION_FAILURE,
  APP_SETTING_CREATE_PROJECT_VERSION_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function createProjectVersion(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_CREATE_PROJECT_VERSION_BEGIN,
    });
    const { projectId } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      console.log(
        'The code is reaching here and this is the project id that is being passed: ',
        projectId,
      );
      console.log('These are the arguments that are being passed : ', args);
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}versions/project/${projectId}/`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_CREATE_PROJECT_VERSION_SUCCESS,
              data: res.data,
            });
            toast.success('Version Created Successfully');
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_CREATE_PROJECT_VERSION_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          const errMsg = err.response.data.message;
          toast.error(`Failed: ${errMsg}`, {});
          dispatch({
            type: APP_SETTING_CREATE_PROJECT_VERSION_FAILURE,
            data: { error: errMsg },
          });
          reject(errMsg);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateProjectVersionError() {
  return {
    type: APP_SETTING_CREATE_PROJECT_VERSION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_CREATE_PROJECT_VERSION_BEGIN:
      return {
        ...state,
        createProjectVersionPending: true,
        createProjectVersionError: null,
      };

    case APP_SETTING_CREATE_PROJECT_VERSION_SUCCESS:
      return {
        ...state,
        createProjectVersionPending: false,
        createProjectVersionError: null,
      };

    case APP_SETTING_CREATE_PROJECT_VERSION_FAILURE:
      return {
        ...state,
        createProjectVersionPending: false,
        createProjectVersionError: action.data.error,
      };

    case APP_SETTING_CREATE_PROJECT_VERSION_DISMISS_ERROR:
      return {
        ...state,
        createProjectVersionError: null,
      };

    default:
      return state;
  }
}
